var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-l-15 p-r-15 p-t-15" },
    [
      _c(
        "legend",
        { staticClass: "f-s-13 p-b-10 display-flex flex--justify-between" },
        [
          _vm._t("title", function() {
            return [_vm._v("\n      Users\n    ")]
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-xs btn-danger legend-right-button",
              attrs: { type: "button", "data-testid": "close-button" },
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [
              _c("i", { staticClass: "typcn typcn-delete" }),
              _vm._v("\n      " + _vm._s(_vm.closeBtnText) + "\n    ")
            ]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("Invites", {
        attrs: {
          "invite-target-id": _vm.buyerId,
          "invite-target-type": _vm.inviteTargetType
        },
        on: {
          "created-new-invite": function($event) {
            return _vm.$emit("created-new-invite", _vm.buyerId)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }